import React from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { Button, Form, Grid, Header, Image, Segment , Divider,Label} from 'semantic-ui-react'
import semanticFormField from 'Features/ui/components/semanticForm'

const emailaddress = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? <Label basic color='red' pointing>Invalid email address</Label>
    : undefined

const LoginBSRSForm = ({ handleSubmit }) => (
    <div>
    <Grid
      textAlign='center'
      style={{ height: '100%' }}
      verticalAlign='middle'
    >
      <Grid.Column style={{ maxWidth: 450 }}>
        <Image size='big'
               src='/assets/images/logo.png'
          />
        <Header as='h2' color='pink' textAlign='center'>
        
          {' '}Log-in to your account
        </Header>
        <Form size='large'>
          <Segment stacked>

            <Field 
                component={semanticFormField}
                as={Form.Input}
                type='text' 
                name='emailaddress' 
                label='Email:'
                validate={emailaddress}
            />
            <Divider />

            <Field 
               component={semanticFormField}
               as={Form.Input}
                type='password' 
                name='password' 
                label='Password:'
            />
            <Button color='pink' fluid size='large' onClick={handleSubmit}>Login</Button>
          </Segment>
        </Form>
      </Grid.Column>
    </Grid> 
    </div>
)

LoginBSRSForm.propTypes = {
    onSubmit: PropTypes.func.isRequired
}

function validate(values){
    let errors = {}
    if(!values.emailaddress) errors.emailaddress= <Label basic color='red' pointing>Required!</Label>
    if(!values.password) errors.password=  <Label basic color='red' pointing>Required!</Label>
    
    return errors
}

export default reduxForm({
    form: 'loginBSRS',
    validate
})(LoginBSRSForm)


// WEBPACK FOOTER //
// ./src/features/auth/components/LoginBSRSForm.js